/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description All Codes Icon
 */

/**
 * All Codes Icon
 */
const AllCodesIcon: React.FC = () => {
	return (
		<span className='anticon anticon-icon'>
			<svg width='16' height='16' viewBox='0 0 16 16' fill='#232835' xmlns='http://www.w3.org/2000/svg' aria-label='All Codes'>
				<g clipPath='url(#clip0_8532_135642)'>
					<path
						d='M3.60352 2.87598V5.47852C3.60336 5.68588 3.50719 5.88208 3.34375 6.00977L1.76855 7.2373L3.27148 8.125C3.47673 8.24622 3.60339 8.46671 3.60352 8.70508V12.0996H2.25488V9.08984L0.231445 7.89648C0.0394796 7.78309 -0.0840994 7.58165 -0.0986328 7.35938C-0.112928 7.13695 -0.0162927 6.92129 0.15918 6.78418L2.25488 5.14746V2.87598H3.60352Z'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='0.2'
					/>
					<path
						d='M12.6455 2.90039C12.5903 2.90039 12.5449 2.94477 12.5449 3V5.50293C12.5451 5.71029 12.6412 5.9065 12.8047 6.03418L14.3799 7.26172L12.877 8.14941C12.6717 8.27064 12.5451 8.49112 12.5449 8.72949V12.0244C12.5449 12.0796 12.5903 12.124 12.6455 12.124H13.7939C13.8491 12.1239 13.8936 12.0796 13.8936 12.0244V9.11426C13.9033 9.10852 13.9145 9.10198 13.9268 9.09473C13.9793 9.06375 14.0548 9.01933 14.1455 8.96582C14.327 8.85876 14.5707 8.71507 14.8193 8.56836C15.3169 8.27479 15.8352 7.96918 15.917 7.9209C16.109 7.8075 16.2325 7.60606 16.2471 7.38379C16.2614 7.16137 16.1647 6.94571 15.9893 6.80859L13.8936 5.17188V3C13.8936 2.94484 13.8491 2.9005 13.7939 2.90039H12.6455Z'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='0.2'
						strokeLinejoin='round'
					/>
					<path
						d='M6.1084 0.900391V2.24805H2.90039V0.900391H6.1084Z'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='0.2'
					/>
					<path d='M6.1084 12.9004V14.248H2.90039V12.9004H6.1084Z' fill='currentColor' stroke='currentColor' strokeWidth='0.2' />
					<path
						d='M13.1084 0.900391V2.24805H9.90039V0.900391H13.1084Z'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='0.2'
					/>
					<path
						d='M13.1084 12.9004V14.248H9.90039V12.9004H13.1084Z'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='0.2'
					/>
					<path
						d='M10.9717 11.3563L9.82243 9.82772C11.0658 8.63709 11.2332 6.70801 10.2032 5.32827C9.66068 4.60153 8.86525 4.12921 7.9639 3.99838C7.06256 3.86755 6.16567 4.09423 5.43893 4.63673C4.7122 5.17924 4.23987 5.97467 4.10904 6.87601C3.97821 7.77736 4.20489 8.67425 4.7474 9.40099C5.2899 10.1277 6.08534 10.6 6.98668 10.7309C7.73167 10.839 8.50351 10.6975 9.16023 10.3139L10.2976 11.8594C10.3684 11.9542 10.4642 12.0057 10.5746 12.0217C10.6849 12.0378 10.7928 12.0065 10.8862 11.9449C11.0745 11.8126 11.1132 11.5458 10.9717 11.3563ZM10.0138 7.73309C9.91498 8.41369 9.55614 9.0096 9.00846 9.41844C8.46077 9.82729 7.77824 10.0006 7.10683 9.90311C6.43542 9.80565 5.83032 9.44548 5.42147 8.89779C5.01263 8.35011 4.83935 7.66757 4.93681 6.99616C5.0356 6.31556 5.39444 5.71965 5.94213 5.31081C6.48981 4.90196 7.17234 4.72869 7.84375 4.82614C8.52436 4.92493 9.12027 5.28377 9.52911 5.83146C9.93796 6.37914 10.1126 7.05248 10.0138 7.73309Z'
						fill='currentColor'
					/>
					<path
						d='M8.03014 5.83594V7.09403H9.31065V7.88556H8.03014V9.14365H7.23861V7.88556H6.00293V7.09403H7.23861V5.83594H8.03014Z'
						fill='currentColor'
						stroke='currentColor'
						strokeWidth='0.189012'
					/>
				</g>
				<defs>
					<clipPath id='clip0_8532_135642'>
						<rect width='16' height='16' fill='white' />
					</clipPath>
				</defs>
			</svg>
		</span>
	);
};

export default AllCodesIcon;
